/**
 * Created by caoyu on 2022/4/19.
 */


export function getLoginRouter() {
  return {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/Login.vue'),
    meta: {shortName: "", tenantId: "", layout: ""}
  };
}



// WEBPACK FOOTER //
// ./src/router/loginRoute.js